import { primaryColor, blackColors, hexToRgb, whiteColor } from 'assets/jss/material-dashboard-pro-react';

import { darken } from '@material-ui/core/styles';

const downloadMenuStyle = () => ({
	iconMenuActive: {
		cursor: 'pointer',
		color: primaryColor[0],
		'&:hover': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
		},
		'&:active': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.3)`,
		},
	},
	iconMenuDisabled: {
		color: blackColors[4],
	},
	iconMenu: {
		display: 'inline-block',
		padding: '6px 4px',
		borderRadius: 4,
		lineHeight: 1,
	},
	iconArrow: {
		fontSize: 8,
		position: 'relative',
		top: -9,
		left: -3,
	},
	downloadDropdown: {
		'& .MuiPaper-root': {
			borderRadius: 4,
			minWidth: 168,
			'& .MuiList-root': {
				padding: '8px 0',
				'& .MuiButtonBase-root': {
					padding: '11px 8px',
					borderRadius: 0,
					margin: 0,
					boxShadow: 'none',
					'&:focus': {
						backgroundColor: whiteColor,
						color: `${blackColors[1]}!important`,
					},
					'&:hover': {
						backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
						color: 'inherit',
					},
					'&:active': {
						backgroundColor: darken(primaryColor[0], 0.12),
						'& p': {
							color: whiteColor + ' !important',
						},
					},
					'& p': {
						margin: 0,
					},
				},
			},
		},
	},
});

export default downloadMenuStyle;
